import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_Salary_Person_Interface, Salary_Person_Interface } from 'src/app/Interface/Salary_Person_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalaryPersonForm',
  templateUrl: './SalaryPersonForm.component.html',
  styleUrls: ['./SalaryPersonForm.component.scss']
})
export class SalaryPersonFormComponent implements OnInit {

  @Input() inner_Year:number=0
  @Input() inner_PersonId:number=0
  @Input() inner_Person_Fullname:string=''
  @Output() outter_Salary= new EventEmitter<number>();

  constructor(
    private Salary_Service: SalaryService,
    private Alertify_Service: AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewSalary = new FormGroup({
      id: new FormControl(),
      Payeh: new FormControl(null, Validators.required),
      Shift: new FormControl(null, Validators.required),
      Tajrobeh: new FormControl(null, Validators.required),
      Kpi: new FormControl(null, Validators.required),
      AyabZohab: new FormControl(null, Validators.required),
    })

    this.OnGetData()
  }



  OnGetData() {
    this.Salary_Service.GetSinglePerson(this.inner_Year,this.inner_PersonId).subscribe(
      data => {

        this.get_Form_Payeh().setValue(data['payeh'])
        this.get_Form_Shift().setValue(data['shift'])
        this.get_Form_AyabZohab().setValue(data['ayabZohab'])
        this.get_Form_Tajrobeh().setValue(data['tajrobeh'])
        this.get_Form_Kpi().setValue(data['kpi'])
      }
    )
  }



  //#region  Form Add

  AddNewSalary: FormGroup;

  get_Form_Payeh() {
    return this.AddNewSalary.get('Payeh') as FormControl;
  }

  get_Form_Shift() {
    return this.AddNewSalary.get('Shift') as FormControl;
  }

  get_Form_Tajrobeh() {
    return this.AddNewSalary.get('Tajrobeh') as FormControl;
  }

  get_Form_Kpi() {
    return this.AddNewSalary.get('Kpi') as FormControl;
  }

  get_Form_AyabZohab() {
    return this.AddNewSalary.get('AyabZohab') as FormControl;
  }
 


  //#endregion

  InProccessing: boolean = false

  SubmitAddNewSalary() {
    var Record: Salary_Person_Interface=Empty_Salary_Person_Interface()
    Record.year = this.inner_Year
    Record.person_id = this.inner_PersonId
    Record.id = 0
    Record.payeh = Number(this.get_Form_Payeh().value)
    Record.shift = Number(this.get_Form_Shift().value)
    Record.tajrobeh = Number(this.get_Form_Tajrobeh().value)
    Record.kpi = Number(this.get_Form_Kpi().value)
    Record.ayabZohab = Number(this.get_Form_AyabZohab().value)


    this.InProccessing = true
    this.Salary_Service.AddPerson(Record).subscribe(
      data => {
        this.InProccessing = false
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  onBack(){
    this.outter_Salary.emit(-1);
  }

}
